<template lang="html">
  <v-container fluid>
    <div class="banner-top-home">
      <div class="banner-home">
        <div class="banner-background-circle" />
        <div class="banner-home-content">
          <div class="banner-image">
            <template v-if="$store.state.selected_store">
              <img :src="$store.state.selected_store.logo" alt="Logo">
            </template>
          </div>
          <div class="banner-text text-center">
            <template v-if="$store.state.selected_store">
              {{ $store.state.selected_store.name }}
            </template>
          </div>
        </div>
      </div>
    </div>
    <v-row class="mt-0">
      <v-col v-if="!$store.state.selected_store.setting.use_takeaway && !$store.state.selected_store.setting.use_delivery && !$store.state.selected_store.setting.use_dinein && !$store.state.selected_store.setting.use_reservation && !$store.state.selected_store.setting.use_place_reservation" cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="text-center">
        <div class="mt-5">
          <img src="@/assets/images/no_data.png" alt="No data" width="100%" class="mb-2">
        </div>
        <div class="mx-auto mb-6" style="max-width: 312px; font-size: 18px; font-weight: 700;">
          {{ $t('no_services_are_available') }}
        </div>
      </v-col>
      <template v-else>
        <v-col v-if="$store.state.selected_store.setting.use_takeaway === 1" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <template v-if="$store.state.selected_store">
            <v-card class="card-menu-type" :disabled="($store.state.selected_store.setting.use_takeaway === 0) ? true : false" @click="selectTakeAway">
              <div class="card-wrapper">
                <span v-if="$store.state.selected_store.setting.use_takeaway === 0" class="tag__coming-soon">
                  {{ $t('not_activated_yet') }}
                </span>
                <div class="card-image">
                  <img src="@/assets/images/svg/menu-takeaway.svg" alt="Take Away">
                </div>
                <div class="card-text">
                  <div class="card-title mr-1 primary--text">
                    <h3>
                      {{ $t('takeaway') }}
                    </h3>
                  </div>
                  <div class="card-subtitle">
                    <h5>
                      {{ $t('order_pickup') }}
                    </h5>
                  </div>
                </div>
              </div>
            </v-card>
          </template>
        </v-col>
        <v-col v-if="$store.state.selected_store.setting.use_delivery === 1" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <template v-if="$store.state.selected_store">
            <v-card class="card-menu-type" :disabled="($store.state.selected_store.setting.use_delivery === 0) ? true : false" @click="selectDelivery">
              <div class="card-wrapper">
                <span v-if="$store.state.selected_store.setting.use_delivery === 0" class="tag__coming-soon">
                  {{ $t('not_activated_yet') }}
                </span>
                <div class="card-image">
                  <img src="@/assets/images/svg/menu-delivery.svg" alt="Delivery">
                </div>
                <div class="card-text">
                  <div class="card-title mr-1 primary--text">
                    <h3>
                      {{ $t('delivery') }}
                    </h3>
                  </div>
                  <div class="card-subtitle">
                    <h5>
                      {{ $t('order_delivery') }}
                    </h5>
                  </div>
                </div>
              </div>
            </v-card>
          </template>
        </v-col>
        <v-col v-if="$store.state.selected_store.setting.use_dinein === 1" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <v-card class="card-menu-type" :disabled="($store.state.selected_store.setting.use_dinein === 0) ? true : false" @click="selectDineIn">
            <div class="card-wrapper">
              <span v-if="$store.state.selected_store.setting.use_dinein === 0" class="tag__coming-soon">
                {{ $t('not_activated_yet') }}
              </span>
              <div class="card-image">
                <img src="@/assets/images/svg/menu-dinein.svg" alt="Dine In">
              </div>
              <div class="card-text">
                <div class="card-title mr-1 primary--text">
                  <h3>
                    {{ $t('dinein') }}
                  </h3>
                </div>
                <div class="card-subtitle">
                  <h5>
                    {{ $t('order_dinein') }}
                  </h5>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col v-if="$store.state.selected_store.setting.use_reservation === 1" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <v-card class="card-menu-type" :disabled="($store.state.selected_store.setting.use_reservation === 0) ? true : false" @click="selectReservation">
            <div class="card-wrapper">
              <span v-if="$store.state.selected_store.setting.use_reservation === 0" class="tag__coming-soon">
                {{ $t('not_activated_yet') }}
              </span>
              <div class="card-image">
                <img src="@/assets/images/svg/menu-reservation.svg" alt="Reservasi">
              </div>
              <div class="card-text">
                <div class="card-title mr-1 primary--text">
                  <h3>
                    {{ $t('reservation') }}
                  </h3>
                </div>
                <div class="card-subtitle">
                  <h5>
                    {{ $t('order_reservation') }}
                  </h5>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col v-if="$store.state.selected_store.setting.use_place_reservation === 1 && isPlaceReservation" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <v-card class="card-menu-type" :disabled="($store.state.selected_store.setting.use_place_reservation === 0) ? true : false" @click="goToPlaceReservation">
            <div class="card-wrapper">
              <span v-if="$store.state.selected_store.setting.use_place_reservation === 0" class="tag__coming-soon">
                {{ $t('not_activated_yet') }}
              </span>
              <div class="card-image">
                <img src="@/assets/images/svg/menu-reservation.svg" alt="Reservasi">
              </div>
              <div class="card-text">
                <div class="card-title mr-1 primary--text">
                  <h3>
                    {{ $t('reservation_place') }}
                  </h3>
                </div>
                <!-- <div class="card-subtitle">
                  <h5>
                    {{ $t('order_reservation') }}
                  </h5>
                </div> -->
              </div>
            </div>
          </v-card>
        </v-col>
      </template>
      <!-- <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-card class="card-menu-type" @click="selectMenuBook">
          <div class="card-wrapper">
            <span v-if="$store.state.selected_store.setting.use_reservation === 0" class="tag__coming-soon">
              Belum di aktivasi
            </span>
            <div class="card-image">
              <img src="@/assets/images/svg/menu-reservation.svg" alt="Reservasi">
            </div>
            <div class="card-text">
              <div class="card-title mr-1 primary--text">
                <h3>
                  Buku menu
                </h3>
              </div>
              <div class="card-subtitle">
                <h5>
                  {{ $t('order_reservation') }}
                </h5>
              </div>
            </div>
          </div>
        </v-card>
      </v-col> -->
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="mt-3">
        <div class="powered-by text-center">
          <p class="mb-0">
            powered by
          </p>
          <div class="powered-by-olsera cursor-pointer" @click="gotoOlsera()">
            <img src="@/assets/images/olsera_logo.png" alt="Olsera.com">
          </div>
        </div>
      </v-col>
      <v-dialog v-model="dialog.dinein" max-width="320" persistent>
        <v-card style="border-radius: 10px;">
          <v-card-text class="pt-8">
            <v-img src="@/assets/images/scanqr.png" width="166" class="mx-auto mb-6" />
            <div class="text-center font-18 font-weight-bold mb-6" style="color: #272727;">
              {{ $t('scan_qr_dinein') }}
            </div>
            <v-btn color="white" block class="text-none" @click="dialog.dinein = false">
              Ok
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: {
        dinein: false
      }
    }
  },
  computed: {
    isPlaceReservation() {
      // const domain_id = this.$store.state.url_domain
      // if (['infinitybeach', 'infinitybeachtest', 'infinitybeachclub'].indexOf(domain_id) !== -1) {
      //   return true
      // } else {
      //   return false
      // }
      return true
    }
  },
  created: function() {
    this.$store.dispatch('saveSelectedType', '')
    this.$store.dispatch('remove_order')
  },
  methods: {
    gotoOlsera() {
      window.open(
        'https://www.olsera.com/id/online',
        '_blank' // <- This is what makes it open in a new window.
      )
    },
    selectReservation() {
      this.$store.dispatch('saveSelectedType', 'RESERVATION')
      this.$router.push({ name: 'listoutlets' }).catch(e => {})
    },
    selectTakeAway() {
      this.$store.dispatch('saveSelectedType', 'OL-TAKE-AWAY')
      this.$router.push({ name: 'listoutlets' }).catch(e => {})
    },
    selectDelivery() {
      this.$store.dispatch('saveSelectedType', 'DELIVERY')
      this.$router.push({ name: 'listoutlets' }).catch(e => {})
    },
    selectDineIn() {
      this.dialog.dinein = true
      // this.$store.dispatch('saveSelectedType', 'DINE-IN')
      // this.$router.push({ path: '/dinein' }).catch(e => {})
    },
    selectMenuBook() {
      this.$router.push({ name: 'menu_book' }).catch(e => {})
    },
    goToPlaceReservation() {
      this.$store.dispatch('saveSelectedType', 'RESERVATION')
      this.$router.push({ name: 'reservation_place' }).catch(e => {})
    }
  }
}
</script>
